<template>
  <div class="custom-map-container">
    <button
      class="custom-map-toggle-button"
      :class="{ 'is-active': showSidebar }"
      @click="showSidebar = !showSidebar"
    >
      <svg
        v-if="!showSidebar"
        class="toggle-icon"
        width="26"
        height="34"
        viewBox="0 0 26 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="26"
          y="34"
          width="26"
          height="34"
          rx="4"
          transform="rotate(180 26 34)"
          fill="#FF0020"
        />
        <path
          d="M18.5708 16.1423C19.2182 16.5307 19.2182 17.4689 18.5708 17.8573L9.5145 23.2911C8.84797 23.691 8 23.2109 8 22.4336L8 11.566C8 10.7887 8.84797 10.3086 9.5145 10.7085L18.5708 16.1423Z"
          fill="white"
        />
      </svg>

      <svg
        v-if="showSidebar"
        class="toggle-icon"
        width="26"
        height="34"
        viewBox="0 0 26 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="26" height="34" rx="4" fill="#FF0020" />
        <path
          d="M7.42915 17.8577C6.78181 17.4693 6.78182 16.5311 7.42915 16.1427L16.4855 10.7089C17.152 10.309 18 10.7891 18 11.5664L18 22.434C18 23.2113 17.152 23.6914 16.4855 23.2915L7.42915 17.8577Z"
          fill="white"
        />
      </svg>
    </button>
    <div class="custom-map-sidebar" :class="{ 'is-visible': showSidebar }">
      <div class="custom-map-sidebar-header">
        <h3 class="custom-map-sidebar-header__title">
          Выберите интересующую вас категорию ниже
        </h3>
      </div>
      <div class="custom-map-sidebar__list">
        <div
          v-for="item in mapList"
          :key="item.name"
          class="category-card"
          @click="selectCategory(item.slug)"
        >
          <div
            class="category-card-marker"
            :class="{ 'is-active': selectedCategory === item.slug }"
          >
            <div class="category-card-marker__image">
              <img :src="getMarkerIcon(item.slug)" :alt="item.name" />
            </div>
          </div>
          <span class="category-card__name">{{ item.name }}</span>
          <span class="category-card__count">{{
            item?.additional_points?.length
          }}</span>
        </div>
      </div>
    </div>
    <div class="mobile-horizontal-sidebar">
      <div class="mobile-categories-list">
        <div
          v-for="item in mapList"
          :key="item.name"
          class="mobile-category-card"
          :class="{ 'is-active': selectedCategory === item.slug }"
          @click="selectCategory(item.slug)"
        >
          <div class="mobile-category-icon">
            <img :src="getMarkerIcon(item.slug)" :alt="item.name" />
          </div>
          <span class="mobile-category-name">{{ item.name }}</span>
          <span class="mobile-category-count">{{
            item?.additional_points?.length
          }}</span>
        </div>
      </div>
    </div>
    <div
      class="map-wrapper"
      @wheel.passive.capture="wheelHandler"
      @mousedown.passive="overlay = false"
      @touchstart.passive="touchHandler"
    >
      <yandex-map
        v-model="map"
        :settings="{
          location: {
            center: [113.469519, 52.058269],
            zoom: 14,
          },
        }"
        width="100%"
        height="100%"
      >
        <yandex-map-default-scheme-layer />
        <yandex-map-default-features-layer />
        <yandex-map-controls :settings="{ position: 'right' }">
          <ZoomControls />
        </yandex-map-controls>

        <template v-for="(point, index) in allPoints" :key="`marker-${index}`">
          <yandex-map-marker
            :settings="{
              coordinates: [point.coordinate.y, point.coordinate.x],
              properties: {
                hintContent: point.name || 'Точка',
                balloonContent: point.category || '',
              },
              zIndex: hoveredMarker === index ? 1000 : 1,
            }"
          >
            <div
              class="custom-marker"
              :class="{
                'marker-hover': hoveredMarker === index,
                'marker-hidden': !point.isVisible,
              }"
              @mouseenter="hoveredMarker = index"
              @mouseleave="hoveredMarker = null"
              @click="() => handleMarkerClick(index, point)"
            >
              <div v-if="hoveredMarker === index" class="custom-marker__title">
                <p>{{ point.name }}</p>
              </div>
              <div class="custom-marker__image">
                <img :src="getMarkerIcon(point.category)" :alt="point.name" />
              </div>
            </div>
          </yandex-map-marker>
        </template>
        <yandex-map-marker
          :settings="{
            coordinates: [113.469519, 52.058269],
            properties: {
              hintContent: 'Жилой комплекс',
              balloonContent: 'Адрес ЖК',
            },
            zIndex: hoveredMarker === 'zk' ? 1000 : 1,
          }"
        >
          <div
            class="zk-marker"
            :class="{ 'zk-marker--hover': hoveredMarker === 'zk' }"
            @mouseenter="hoveredMarker = 'zk'"
            @mouseleave="hoveredMarker = null"
            @click="
              () =>
                handleMarkerClick('zk', {
                  coordinate: { y: 113.469519, x: 52.058269 },
                })
            "
          >
            <div v-if="hoveredMarker === 'zk'" class="zk-marker__title">
              <p>Адрес ЖК</p>
            </div>
            <div class="zk-marker__image">
              <img :src="require('@i/marker_office.png')" alt="Адрес ЖК" />
            </div>
          </div>
        </yandex-map-marker>
        <yandex-map-marker
          :settings="{
            coordinates: [113.492763, 52.056168],
            properties: {
              hintContent: 'Адрес офиса продаж',
              balloonContent: 'Адрес офиса продаж',
            },
            zIndex: hoveredMarker === 'office' ? 1000 : 1,
          }"
        >
          <div
            class="zk-marker"
            :class="{ 'zk-marker--hover': hoveredMarker === 'office' }"
            @mouseenter="hoveredMarker = 'office'"
            @mouseleave="hoveredMarker = null"
            @click="
              () =>
                handleMarkerClick('office', {
                  coordinate: { y: 113.492763, x: 52.056168 },
                })
            "
          >
            <div v-if="hoveredMarker === 'office'" class="zk-marker__title">
              <p>Адрес офиса продаж</p>
            </div>
            <div class="zk-marker__image">
              <img :src="require('@i/marker.svg')" alt="Адрес офиса продаж" />
            </div>
          </div>
        </yandex-map-marker>
      </yandex-map>
      <div
        class="map-overlay"
        :class="{
          'with-sidebar': showSidebar,
          'is-active': overlay,
          'is-touch-active': isMapTouchActive,
        }"
      >
        <p class="map-overlay__text">
          Чтобы изменить масштаб, <br />
          прокручивайте карту <br />
          удерживая CTRL
        </p>
        <p class="map-overlay__text map-overlay__text_mobile">
          Чтобы активировать карту,
          <br />
          нажмите кнопку ниже
          <br />
        </p>
        <div class="particle"></div>
      </div>
      <button class="btn btn-default btn-small" @click="mobileTouchActivate">
        {{ !isMapTouchActive ? "Активировать карту" : "Деактивировать карту" }}
      </button>
      <div class="map-shade"></div>
    </div>
  </div>
</template>

<script>
import {
  YandexMap,
  YandexMapDefaultSchemeLayer,
  YandexMapDefaultFeaturesLayer,
  YandexMapMarker,
  YandexMapControls,
} from "vue-yandex-maps";
import { computed, inject, ref, shallowRef } from "vue";

import ZoomControls from "@/components/home/ZoomControls.vue";

import allIcon from "@i/infrastructure-category/all.svg";
import busIcon from "@i/infrastructure-category/bus.svg";
import educationIcon from "@i/infrastructure-category/education.svg";
import parksIcon from "@i/infrastructure-category/parks.svg";
import shoppingIcon from "@i/infrastructure-category/purchases.svg";
import sportIcon from "@i/infrastructure-category/sport.svg";
import healthIcon from "@i/infrastructure-category/health.svg";

export default {
  components: {
    YandexMap,
    YandexMapDefaultSchemeLayer,
    YandexMapDefaultFeaturesLayer,
    YandexMapMarker,
    YandexMapControls,
    ZoomControls,
  },
  inject: ["mq", "galleryStore"],
  setup() {
    const mainStore = inject("mainStore");
    const hoveredMarker = ref(null);
    const activeMarker = ref(null);
    const map = shallowRef(null);
    const overlay = ref(false);
    let timeout = null;
    const isMapTouchActive = ref(false);
    const showSidebar = ref(true);
    const selectedCategory = ref("all");

    const iconMapping = {
      all: allIcon,
      transport: busIcon,
      education: educationIcon,
      parks: parksIcon,
      shopping: shoppingIcon,
      products: shoppingIcon,
      sport: sportIcon,
      health: healthIcon,
    };

    const showZoomOverlay = () => {
      overlay.value = true;

      timeout = setTimeout(() => {
        overlay.value = false;
      }, 1500);
    };

    const getMarkerIcon = (slug) => {
      return iconMapping[slug];
    };

    const handleMarkerClick = (index, point) => {
      activeMarker.value = index;
      if (map.value && point?.coordinate) {
        map.value.setLocation({
          center: [point.coordinate.y, point.coordinate.x],
          duration: 400,
        });
      }
    };

    const mapData = computed(() => {
      return mainStore.state.data?.map_label_categories || { list: [] };
    });

    const allPoints = computed(() => {
      if (!mapData.value?.list?.length) return [];

      const points = [];
      for (const category of mapData.value.list) {
        if (category?.additional_points?.length) {
          for (const point of category.additional_points) {
            if (point?.coordinate?.x && point?.coordinate?.y) {
              points.push({
                ...point,
                category: category.slug,
                isVisible:
                  selectedCategory.value === "all" ||
                  category.slug === selectedCategory.value,
              });
            }
          }
        }
      }
      return points;
    });

    const mapList = computed(() => {
      const categories = mainStore.state.data?.map_label_categories?.list || [];

      return [
        {
          name: "Все",
          slug: "all",
          additional_points: allPoints.value,
        },
        ...categories,
      ];
    });

    const updateMarkersVisibility = () => {
      allPoints.value.forEach((point) => {
        point.isVisible =
          selectedCategory.value === "all" ||
          point.category === selectedCategory.value;
      });
    };

    const selectCategory = (slug) => {
      selectedCategory.value = slug;
      updateMarkersVisibility();
    };

    const wheelHandler = (e) => {
      if (e.ctrlKey) {
        overlay.value = false;
      } else {
        e.stopPropagation();
        clearTimeout(timeout);
        showZoomOverlay();
      }
    };

    const touchHandler = (e) => {
      if (!isMapTouchActive.value) {
        clearTimeout(timeout);
        showZoomOverlay();
      }
    };

    const mobileTouchActivate = () => {
      isMapTouchActive.value = !isMapTouchActive.value;
    };

    return {
      mainStore,
      mapData,
      mapList,
      allPoints,
      hoveredMarker,
      activeMarker,
      handleMarkerClick,
      getMarkerIcon,
      map,
      overlay,
      wheelHandler,
      showZoomOverlay,
      isMapTouchActive,
      touchHandler,
      mobileTouchActivate,
      showSidebar,
      selectedCategory,
      selectCategory,
      updateMarkersVisibility,
    };
  },
};
</script>

<style scoped>
.custom-map-container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 400px;
}

.custom-map-toggle-button {
  position: absolute;
  top: 20px;
  left: 10px;
  z-index: 20;
  gap: 8px;
  padding: 0;
  border: none;
  border-radius: 10px;
  transition: transform 0.3s ease;
}

.custom-map-toggle-button.is-active {
  transform: translateX(442px);
}

.custom-map-sidebar {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  max-width: 442px;
  height: 100%;
  background-color: #fff;
  box-shadow: 2px 0 8px rgb(0 0 0 / 0.1);
  transition: transform 0.3s ease;
  transform: translateX(-100%);
}

.custom-map-sidebar.is-visible {
  overflow-y: auto;
  transform: translateX(0);
}

.custom-map-sidebar-header {
  width: 70%;
  padding: 40px;
}

.custom-map-sidebar-header__title {
  margin: 0;
  color: #ff0020;
  font-weight: 500;
  font-size: 16px;
  text-align: left;
}

.custom-map-sidebar__list {
  display: flex;
  flex-direction: column;
  gap: 19px;
  padding: 40px;
  border-top: 1px solid #eee;
}

.category-card {
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.category-card:hover .category-card-marker {
  background: #800011;
}

.category-card__name {
  flex: 1;
  color: #28281e;
  font-weight: 500;
}

.category-card__count {
  color: hsl(60 14% 14% / 0.6);
  font-weight: 500;
}

.category-card-marker {
  width: 35px;
  height: 35px;
  border-radius: 22px;
  background: #ff0020;
  box-shadow: 0 2px 4px rgb(0 0 0 / 0.1);
  cursor: pointer;
  transition: 0.3s ease;
}

.category-card-marker.is-active {
  background: #800011;
  transform: scale(1.1);
}

.category-card-marker__image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  filter: brightness(0) invert(1);
}

.mobile-horizontal-sidebar {
  display: none;
}

.mobile-horizontal-sidebar::-webkit-scrollbar {
  width: 6px;
  background-color: #fff;
}

.mobile-horizontal-sidebar::-webkit-scrollbar-track {
  border-radius: 0;
  background: #fff;
}

.mobile-horizontal-sidebar::-webkit-scrollbar-thumb {
  border: 4px solid #fff;
  background: #ff0020;
}

.mobile-horizontal-sidebar::-webkit-scrollbar-thumb:hover {
  background: #cc0019;
}

.mobile-horizontal-sidebar::-webkit-scrollbar-button:horizontal:start:decrement {
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='%23FF0020'%3E%3Cpath d='M14 7l-5 5 5 5V7z'/%3E%3C/svg%3E");
  background-position: center;
  background-repeat: no-repeat;
}

.mobile-horizontal-sidebar::-webkit-scrollbar-button:horizontal:end:increment {
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='%23FF0020'%3E%3Cpath d='M10 17l5-5-5-5v10z'/%3E%3C/svg%3E");
  background-position: center;
  background-repeat: no-repeat;
}

.mobile-categories-list {
  display: none;
  display: flex;
  gap: 20px;
  align-items: center;
  width: max-content;
  height: 100%;
  padding: 30px 25px;
}

.mobile-category-card {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  height: 100%;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-category-icon {
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  margin-bottom: 5px;
  border-radius: 50%;
  background: #ff0020;
}

.mobile-category-card.is-active .mobile-category-icon {
  background: #800011;
}

.mobile-category-icon img {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.mobile-category-name {
  color: #28281e;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  white-space: nowrap;
}

.mobile-category-count {
  color: #28281e99;
  font-weight: 500;
  font-size: 16px;
}

.with-mobile-sidebar {
  height: calc(100% - 80px);
}

.map-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 400px;
}

.map-shade {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgb(255 255 255 / 0.8) 0%,
    rgb(255 255 255 / 0) 2%,
    rgb(255 255 255 / 0) 98%,
    rgb(255 255 255 / 0.8) 100%
  );
  pointer-events: none;
}

@media (max-width: 575px) {
  .map-shade {
    background: none;
  }
}

.custom-marker {
  position: relative;
  z-index: 2;
  width: 43px;
  height: 43px;
  border-radius: 22px;
  background: #ff0020;
  box-shadow: 0 2px 4px rgb(0 0 0 / 0.1);
  visibility: visible;
  cursor: pointer;
  transition: all 0.3s ease;
  transition: opacity 0.3s, transform 0.3s, visibility 0s;
}

.marker-hidden {
  position: absolute;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s, transform 0.3s, visibility 0s 0.3s;
  transform: scale(0.5);
}

.custom-marker__title {
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-bottom: 6px;
  padding: 12px;
  border-radius: 6px;
  background-color: #ff0020;
  color: #fff;
  box-shadow: 0 4px 6px rgb(0 0 0 / 0.1);
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  pointer-events: none;
  transition: transform 300ms cubic-bezier(0.2, 0, 0, 1),
    opacity 300ms cubic-bezier(0.2, 0, 0, 1);
  transform: translate(-50%);
}

.custom-marker__image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  filter: brightness(0) invert(1);
}

.custom-marker.marker-hover,
.custom-marker:active {
  z-index: 1000;
  background: #ff4d4d;
  box-shadow: 0 4px 8px rgb(0 0 0 / 0.2);
  transform: scale(1.2);
}

.zk-marker {
  position: relative;
  z-index: 1;
  width: 54px;
  height: 54px;
  border: none;
  border-radius: 50%;
  background: none;
  box-shadow: none;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: translate(-50%, -100%);
}

.zk-marker__title {
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-bottom: 6px;
  padding: 12px;
  border-radius: 6px;
  background-color: #ff0020;
  color: #fff;
  box-shadow: 0 4px 6px rgb(0 0 0 / 0.1);
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  pointer-events: none;
  transition: transform 300ms cubic-bezier(0.2, 0, 0, 1),
    opacity 300ms cubic-bezier(0.2, 0, 0, 1);
  transform: translate(-50%);
}

.zk-marker__image {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.zk-marker__image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
  filter: none;
}

.zk-marker.zk-marker--hover,
.zk-marker:active {
  z-index: 1000;
  transform: translate(-50%, -100%) scale(1.15);
}

.map-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 40px;
  background: #ff002066;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.45s ease-in-out,
    -webkit-backdrop-filter 0.45s ease-in-out;
  transition: opacity 0.45s ease-in-out, backdrop-filter 0.45s ease-in-out;
  transition: opacity 0.45s ease-in-out, backdrop-filter 0.45s ease-in-out,
    -webkit-backdrop-filter 0.45s ease-in-out;
  backdrop-filter: blur(10px);
}

.map-overlay.is-active {
  opacity: 1;
  backdrop-filter: blur(7px);
}

.map-overlay.is-touch-active {
  pointer-events: none;
}

.map-overlay.with-sidebar {
  padding-left: 442px;
}

.map-overlay__text {
  color: #fff;
  font-weight: 600;
  font-size: 40px;
  text-align: center;
}

.map-overlay__text.map-overlay__text_mobile {
  display: none;
}

.btn {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: none;
  margin: 10px 34px;
  font-size: 14px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.particle {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: url(~@i/logo-map-root.svg) 95% center / contain no-repeat;
  pointer-events: none;
}

@media (max-width: 991px) {
  .custom-map-sidebar {
    display: none;
  }

  .custom-map-toggle-button {
    display: none;
  }

  .map-overlay.with-sidebar {
    padding: 40px;
  }

  .mobile-horizontal-sidebar {
    z-index: 20;
    display: block;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    height: max-content;
    background: white;
    box-shadow: 0 2px 8px rgb(0 0 0 / 0.1);
  }
}

@media (max-width: 767px) {
  .map-overlay {
    pointer-events: auto;
  }

  .map-overlay__text {
    display: none;
  }

  .map-overlay__text.map-overlay__text_mobile {
    display: block;
    width: 45%;
    font-size: 20px;
    text-align: center;
  }

  .btn {
    display: block;
  }

  .particle {
    background-position: 120px;
    background-size: auto 100%;
  }
}

@media (max-width: 575px) {
  .map-overlay__text.map-overlay__text_mobile {
    width: 80%;
  }
}
</style>
